const allproject = { data: [], loading: true };
export const GetAllProject = (state = allproject, action) => {
    switch (action.type) {

        case "get_allproject":
            return {
                data: action.payload,
                loading: action.loading
            }
        default:
            return state;
    }


}
